import React from 'react';
import styled from 'styled-components';
import { PaveColor } from '../components/ConfigStyle';

function PaveMaintainance() {
  return (
    <Wrapper>
      <div style={{ padding: 15 }}>
        <h1>
          <i className="fas fa-tools hl" style={{ fontSize: 85 }} />
        </h1>
        <div>
          <p>
            <span>Oops! PAVE Is Currently Under</span>
            <br />
            {` `}
            <span className="hl">Scheduled Maintenance</span>
          </p>
          <p>
            <span>
              All our services will be unavailable at this moment and will be
              back
            </span>{' '}
            {` `}
            <span className="hl">online</span> {` `}
            <span>by</span> {` `} <br />
            <span className="hl">5:00 AM (EST) on Sunday, October 24th</span>
          </p>
          <p>
            We apologize for any inconvenience that this may cause and thank you
            for your patience.
          </p>
        </div>
      </div>
    </Wrapper>
  );
}

export default PaveMaintainance;

const Wrapper = styled.section`
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  background: white;
  position: relative;
  min-height: var(--vh, 100vh);
  text-align: center;
  /* font-family: 'monospace'; */
  background-color: #393c47;
  color: rgb(187, 190, 197);
  font-size: 13px;
  text-transform: uppercase;
  font-weight: 500;
  h1 {
    color: ${PaveColor.primary_green};
    font-weight: 800;
    font-size: 36px;
  }
  .hl {
    color: ${PaveColor.primary_green};
    font-size: 18px;
    font-weight: 800;
  }
`;
